













































































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Video from "@/components/video.vue";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    Video,
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType: string = "bp/wjSubmitData";

  videoModalVisible: boolean = false;
  videoUrl: string = "";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "状态", dataIndex: "stadium_id" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "提交时间", dataIndex: "created_time" },
    { title: "IP", dataIndex: "ip" }
  ];

  showVideoModal(url: string) {
    this.videoUrl = url;
    this.videoModalVisible = true;
  }

  hideVideoModal() {
    this.videoModalVisible = false;
  }

  async loadFields() {
    const res = await this.$store.dispatch("bp/fields", {});
    console.log(res);
    if (res && res.Data) {
      for (const k in res.Data) {
        if (res.Data[k]) {
          this.columns.push({
            title: res.Data[k].title,
            field_type: res.Data[k].field_type,
            dataIndex: res.Data[k].dataIndex
            // children: res.Data[k].childrens
          });
        }
      }
    }

    console.log(this.columns);
    this.loadData();
  }

  mounted() {
    this.loadFields();
  }

  handleUnbindData(stadiumId: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要解除关联吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("bp/unbindData", {
          stadium_id: stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);

          this.loadFields();
        }
      }
    });
  }
}
